












import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";

interface DragReorderableDropAllowed {
    sourceName: string;
    targetName: string;
};

@Component
export default class DragReorderable extends Vue {
    @Prop() private value!: string[];

    sourceName: string | null = null;
    targetName: string | null = null;
    allowDrop = false;

    isDropAllowed(event: DragEvent): this is DragReorderableDropAllowed {
        if (event.dataTransfer === null) {
            throw new Error("Cannot use event without dataTransfer object");
        }
        return !!(
            this.targetName &&
            this.sourceName &&
            this.targetName !== this.sourceName);
    }

    dragended() {
        this.sourceName = null;
        this.targetName = null;
        this.allowDrop = false;
        this.$emit("reorder-drop-active", false);
    }

    getReorderableParentElement(element: Element): Element | null {
        while (element.parentElement !== this.$el) {
            if (element.parentElement === null) {
                return null;
            }
            element = element.parentElement;
        }
        return element;
    }

    getReorderableElementName(element: Element | null): string | null {
        if (element === null) {
            return null;
        }
        const elements = Array.prototype.slice.call(this.$el.children);
        const index = elements.indexOf(element);
        return this.value[index];
    }

    dragstart(event: DragEvent) {
        if (event && (event.target as HTMLElement).className !== "panel-reorder-btn") return;
        const moveable = this.getReorderableParentElement(event.target as Element) as Element;
        this.sourceName = this.getReorderableElementName(moveable);

        if (event.dataTransfer === null) {
            throw new Error("Cannot use event without dataTransfer object");
        }

        const reorderable = moveable.getBoundingClientRect();
        const knob = (event.target as Element).getBoundingClientRect();
        event.dataTransfer.setDragImage(moveable, knob.left - reorderable.left + knob.width / 2,
            knob.top - reorderable.top + knob.height / 2);
        event.dataTransfer.effectAllowed = "move";

        this.$emit("reorder-drop-active", true);
    }

    dragend(event: DragEvent) {
        this.dragended();
    }

    dragenter(event: DragEvent) {
        this.targetName = this.getReorderableElementName(
            this.getReorderableParentElement(event.target as Element));
        if (this.isDropAllowed(event)) {
            this.allowDrop = true;
        }
    }

    dragleave(event: DragEvent) {
        const reorderableParent = this.getReorderableParentElement(event.target as Element);
        if (reorderableParent === (event.target as Element).parentElement) {
            this.targetName = null;
            this.allowDrop = false;
        }
    }

    dragover(event: DragEvent) {
        if (event.dataTransfer === null) {
            throw new Error("Cannot use event without dataTransfer object");
        }

        if (this.isDropAllowed(event)) {
            event.dataTransfer.dropEffect = "move";
            event.preventDefault();
        }
    }

    drop(event: DragEvent) {
        if (this.isDropAllowed(event)) {
            event.preventDefault();
            const targetIndex = this.value.indexOf(this.targetName);
            const sourceIndex = this.value.indexOf(this.sourceName);
            const source = this.value.slice();

            source[targetIndex] = this.sourceName;
            source[sourceIndex] = this.targetName;
            this.$emit("input", source);
            this.dragended();
        }
    }
}
